import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { RolCheck } from "./check";
import { RolTreeType } from "../rolmap";
import { createSelectorRx, enumObject, orderBy } from "keautils";
import { establecerValorTodos, tieneTodosMismoValor } from "./logic";

type Entity = {
    [K in string]: boolean
};
export interface Props {
    value: any;
    /**Arbol que se usara para mostrar los componentes. Si este arbol se filtra también se filtraran los valores de entity */
    tree: any;
    /**El arbol completo sin filtrar, se usa para la seleccion de todos/ninguno */
    fullTree: any;
    depth: number;
    onChange: (value: any) => PromiseLike<void> | void;
}

/**
* Edita un rol dado el rol y el arbol de los roles. El arbol de los roles determina los elementos que se van a mostraer
*/
export class RolTreeComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;

    handleOnTodos = () => {
        const oldValue = this.props.value;
        const nextValue = establecerValorTodos(this.props.fullTree, oldValue, true);
        this.props.onChange(nextValue);
    }
    handleOnNinguno = () => {
        const oldValue = this.props.value;
        const nextValue = establecerValorTodos(this.props.fullTree, oldValue, false);
        this.props.onChange(nextValue);
    }

    render() {
        const { value, tree, fullTree, depth } = this.props;

        const items = orderBy(enumObject(tree), x => x.key);
        const tieneTodos = tieneTodosMismoValor(fullTree, value, true, "");
        const tieneNinguno = tieneTodosMismoValor(fullTree, value, false, "");
        return (
            <div>
                <div className="btn-group">
                    <kea.Button onClick={this.handleOnTodos} style={tieneTodos ? "info" : "default"} >
                        Todos
                    </kea.Button>
                    <kea.Button onClick={this.handleOnNinguno} style={tieneNinguno ? "info" : "default"}>
                        Ninguno
                    </kea.Button>
                </div>
                {items.map(x => {
                    const val = value[x.key];
                    const onChange = val => {
                        const oldVal = value;
                        const nextVal = { ...oldVal, [x.key]: val };
                        this.props.onChange(nextVal);
                    };

                    return (
                        <div>
                            {typeof (x.value) == "string" ?
                                <RolCheck
                                    label={x.key as string}
                                    descripcion={x.value}
                                    value={val}
                                    onChange={onChange}
                                /> :
                                typeof (x.value) == "object" ?
                                    <div style={{
                                        padding: "1px 1px 1px 10px",
                                        margin: "3px",
                                        borderWidth: "1px",
                                        borderStyle: "solid",
                                        borderColor: "rgba(0,0,0,0.2)"
                                    }} >
                                        <label>
                                            {x.key}
                                        </label>
                                        <hr />
                                        <RolTreeComponent
                                            value={val || {}}
                                            onChange={onChange}
                                            tree={tree[x.key] || {}}
                                            fullTree={fullTree[x.key] || {}}
                                            depth={depth + 1}
                                        />
                                    </div> :
                                    null
                            }
                        </div>
                    )
                }
                )
                }
            </div >);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/edit/componentes/roltree.tsx